import { useState } from "react";
import { signOut } from "../firebase/auth/functions.tsx";
import LoadingBarApp from "../widgets/loading";

export default function LogoutPage() {
    signOut(true);

    return <LoadingBarApp/>;
}